import { Story } from '@/lib/types';
import Link from 'next/link';

export default function MostRead({ initialData }: { initialData?: Story[] }) {
  const stories = initialData || [];

  return (
    <div>
      <div className="flex items-baseline justify-between mb-4 pb-2.5 border-b-[2.5px] border-[#0D0D0D]">
        <h3 className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[12px] tracking-[0.1em] uppercase text-[#0D0D0D]">
          Most Read
        </h3>
        <Link href="/latest" className="font-['IBM_Plex_Sans',system-ui,sans-serif] font-semibold text-[12px] uppercase tracking-[0.04em] text-[#C8102E] hover:text-[#9E0C23]">
          See all →
        </Link>
      </div>
      <ol className="space-y-0">
        {stories.map((story, i) => (
          <li key={story.id}>
            <Link
              href={`/article/${story.slug}`}
              className="flex items-start gap-4 py-3.5 border-b border-[#D4D4D4] group cursor-pointer hover:opacity-75 transition-opacity"
            >
              <span className="font-['Playfair_Display',Georgia,serif] font-bold text-[22px] text-[#D4D4D4] leading-none shrink-0 w-7 text-right">
                {i + 1}
              </span>
              <div>
                <h4 className="font-['Playfair_Display',Georgia,serif] font-semibold text-[14px] leading-[1.35] text-[#0D0D0D] group-hover:text-[#C8102E] transition-colors">
                  {story.title}
                </h4>
                <div className="font-['IBM_Plex_Sans',system-ui,sans-serif] text-[11px] text-[#6B6B6B] mt-1">
                  {story.section} · {story.publishedAt}
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </div>
  );
}
